<template>
  <v-container class="my-5 py-5" fluid fill-height>
    <v-row class="my-5 py-5 align-center justify-center">
      <div class="mr-3 hidden-sm-and-down">
        <img :src="require('@/assets/errors/403.svg')" alt="Error">
      </div>
      <div class="text-md-center">
        <h1>403</h1>
        <h2 class="my-3 text-h5">No tiene permisos para acceder al recurso solicitado.</h2>
      </div>
    </v-row>
  </v-container>
</template>

<script>
export default {
}
</script>

<style scoped>
  h1 {
    font-size: 150px;
    line-height: 150px;
    font-weight: 700;
    color: #252932;
    text-shadow: rgba(61, 61, 61, 0.3) 1px 1px, rgba(61, 61, 61, 0.2) 2px 2px, rgba(61, 61, 61, 0.3) 3px 3px;
  }
</style>
